var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":require('./../../../src/assets/background/empty-state-list.svg'),"alt":"No records found"}}),_c('h4',[_vm._v("No records found.")])])}
var staticRenderFns = []

export { render, staticRenderFns }